// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"135":"95267aeb","230":"c9c7c0ad","566":"5e514b37","607":"6e80a6b3"}[chunkId] + ".chunk.css";
};